import { post, get } from '../index'


export const sendSMS = post('/smsCode')
export const getOSSToken = get('/oss/token')




